import { createAction } from 'redux-act';
import { IError } from 'modules/ScrShop/store/types';

export const globalError = createAction<Error | string>();
export const showGlobalError = createAction<IError>();
export const clearGlobalError = createAction();
